import { module } from 'modujs';
import { gsap } from "gsap";
import { ENV } from '../config';

export default class extends module {
    constructor(m) {
        super(m);

        this.tlBg = gsap.timeline({ paused: true });
        this.tlBg.fromTo(
            '.m-services_backgrounds_item',
            { scale: 1.15, clipPath: "polygon(0 0, 100% 0, 100% 0, 0 0)" },
            { scale: 1, clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)", duration: 0.8, ease: "power2.inOut", stagger: { each: 0.6, from: 'start' } },
            0
        );
        this.tlBg.add('content');
        this.tlBg.fromTo(
            '.m-services_intro_inner .c-surtitle',
            { opacity: 0 },
            { opacity: 1, duration: 0.2, ease: "none" },
            'content-=0.2'
        );
        this.tlBg.fromTo(
            '.m-services_intro_item',
            { y: '100%' },
            { y: '0', duration: 0.4, ease: "power2.out", stagger: { each: 0.35, from: 'start' } },
            'content'
        );
        this.tlBg.fromTo(
            '.m-services_backgrounds_mask',
            { opacity: 0 },
            { opacity: 1, duration: 0.2, ease: "none" },
            'content+=0.2'
        );
        let clipPath = ENV.IS_SM ? "inset(15% 15% 15% 15%)" : "inset(15% 35% 15% 35%)";
        this.tlBg.fromTo(
            '.m-services_backgrounds',
            { clipPath: "inset(0 0 0 0)" },
            { clipPath: clipPath, duration: 0.6, ease: "power2.out" },
            'content+=0.3'
        );

        window.addEventListener('servicesBg', (e) => {
            const { target, progress } = e.detail;
            if (this.tlBg) {
                this.tlBg.progress(progress);
            }
        });
    }

    init() {
    }
}
